export default __webpack_public_path__ + "static/media/streamer_avatar14.4aab24de.png";